import React, { useRef, useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { toast } from 'react-toastify';

import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { isArray, isEmpty } from 'lodash';
import * as Yup from 'yup';

import Tabela from '../Tabela';

import { Table } from '~/components';

import { Form, Input, Autocomplete } from '~/components/Form'
import { t } from '~/helpers';
import api from '~/services/api';

import qs from 'querystring';

import * as S from './styles';

import {
  TextField,
  Button,
  MenuItem,

} from '@material-ui/core';


import {
  deleteoperacaobloqueioprefaturageradaitem,
  recordFilteringVeiculo,
  findVeiculosBloqueadosPreFaturaGerada,
  veiculosBloqueadosPreFaturaGeradaInRequest,
} from '~/store/modules/operacaobloqueioprefaturageradaitem/actions';

export default function RemoverBloqueio({ data, sending, close }) {
  const formRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const { profile } = useSelector((state) => state.user);

  const handleSubmit = useCallback(async (dataForm) => {
    try {

      const schema = Yup.object().shape({
        apbf_observacao: Yup.string()        
        .required(t('s.geral.validacao.campoobrigatorio'))
        .min(1, t('s.geral.validacao.tamanhominimo').replace('%s', 1))
        .max(499, t('s.geral.validacao.tamanhomaximo').replace('%s', 499))
        ,
      });

      const login = profile.glousuariologin;
      await schema.validate(dataForm, {
        abortEarly: false,
      });

      const objSend = {
        preFatura: data.fatu_codigo,
        placa: data.veic_placa,
        login: login,
        acao: 'R',
        observacao: dataForm.apbf_observacao,
      };

      await api.put(
        'operacaobloqueioprefaturageradaitemhistoricoitem/editar',
        objSend
      );
      toast.success(t('s.geral.sucessoalteracao'));


      await close();
    } catch (err) {
      const validationErrors = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          validationErrors[error.path] = error.message.replace(
            `${error.path} `,
            ''
          );
        });

        formRef.current.setErrors(validationErrors);
      }
    }
  }, [data]);

  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);



  return (
    <Form ref={formRef} onSubmit={handleSubmit} initialData={data}>
      <S.Wrapper>
        

          <Input name="veic_placa" label="Veículo" disabled />

          <Input name="apbf_observacao" label="Observação" type="text" 
          multiline
          rows={10}
          />

        
      </S.Wrapper>
    </Form>
  );
}

RemoverBloqueio.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  sending: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
}
